import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { Button as ActionButton } from '@calendly/ui/components/button';
import { ArrowChevronLeftMiniIcon } from '@calendly/ui/components/icons';
import { Link } from '@calendly/ui/components/link';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import Day from 'components/core/calendar/day';
const wrapperCss = "w1tfb88";
export const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
const footerCss = "f1qky5x0";
export const Footer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(footerCss, props.className)} />;
});
const actionsCss = "a1tv8bx3";
export const Actions = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(actionsCss, props.className)} />;
});
const calendarWrapperCss = "cjlt68d";
export const CalendarWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(calendarWrapperCss, props.className)} />;
});
const titleCss = "t1ee25gk";
export const Title = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(titleCss, props.className)} />;
});
const headingCss = "h162eetb";
export const Heading = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'th';
  return <Component ref={ref} {...restProps} className={classNames(headingCss, props.className)} />;
});
const tableIsTabletUpCss = "t1b5v6ur";
const tableCss = "t1a6z4ng";
export const Table = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'table';
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(tableCss, {
    [tableIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
const headerCss = "hi9nmk9";
export const Header = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headerCss, props.className)} />;
});
const buttonCss = "b1qt5iu";
export const Button = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(buttonCss, props.className)} />);
const navigationWrapperCss = "nuzr0f6";
export const NavigationWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(navigationWrapperCss, props.className)} />;
});
const styledDayCss = "s1g7adwu";
export const StyledDay = forwardRef((props, ref) => <Day ref={ref} {...props} className={classNames(styledDayCss, props.className)} />);
const backLinkCss = "b10tlryz";
export const BackLink = forwardRef((props, ref) => {
  const as = 'button';
  const underline = false;
  return <Link ref={ref} {...props} as={as} underline={underline} className={classNames(backLinkCss, props.className)}>
      <ArrowChevronLeftMiniIcon />
      {I18n.t('publisher.action.back')}
    </Link>;
});
const styledButtonIsMobileCss = "sjazhxi";
const styledButtonCss = "s1sorj1y";
export const StyledButton = forwardRef((props, ref) => {
  const isMobile = useDeviceType('isPhone');
  return <ActionButton ref={ref} {...props} className={classNames(styledButtonCss, {
    [styledButtonIsMobileCss]: isMobile
  }, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");